"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceUrlParameters = exports.FOCAL_POINT_AUTO = exports.ImageOutputFormat = exports.LOSSLESS_IMAGE = void 0;
exports.LOSSLESS_IMAGE = 'data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==';
var ImageOutputFormat;
(function (ImageOutputFormat) {
    /**
     * Use the image enhancement service to resize and optimize images.
     * This is the default behavior.
     */
    ImageOutputFormat["WEBP"] = "webp";
})(ImageOutputFormat = exports.ImageOutputFormat || (exports.ImageOutputFormat = {}));
exports.FOCAL_POINT_AUTO = 'auto';
var ServiceUrlParameters;
(function (ServiceUrlParameters) {
    ServiceUrlParameters["URL"] = "url";
    ServiceUrlParameters["WIDTH"] = "w";
    ServiceUrlParameters["HEIGHT"] = "h";
    ServiceUrlParameters["DEVICE_PIXEL_RATIO"] = "s";
    ServiceUrlParameters["FORMAT"] = "f";
    ServiceUrlParameters["FOCAL_POINT"] = "fp";
})(ServiceUrlParameters = exports.ServiceUrlParameters || (exports.ServiceUrlParameters = {}));
//# sourceMappingURL=constants.js.map